export const isDesktopWidth = (): boolean => {
  return window.innerWidth > 769;
}